// Utility functions to format enum values into user-friendly labels

export const formatProjectCategory = (category: string | null | undefined): string => {
  if (!category) return '';
  
  const categoryMap: Record<string, string> = {
    'KitchenDesign': 'Kitchen Design',
    'BathroomDesign': 'Bathroom Design',
    'LivingRoomDesign': 'Living Room Design',
    'BedroomDesign': 'Bedroom Design',
    'DiningRoomDesign': 'Dining Room Design',
    'HomeOfficeDesign': 'Home Office Design',
    'BasementDesign': 'Basement Design',
    'OutdoorDesign': 'Outdoor Design',
    'WholeHomeDesign': 'Whole Home Design',
    'CommercialDesign': 'Commercial Design',
  };
  
  return categoryMap[category] || category;
};

export const formatBudgetRange = (budget: string | null | undefined): string => {
  if (!budget) return '';
  
  const budgetMap: Record<string, string> = {
    'upToThreeK': 'Up to $3,000',
    'ThreeKToFiveK': '$3,000 - $5,000',
    'FiveKToTenK': '$5,000 - $10,000',
    'TenKToFifteenK': '$10,000 - $15,000',
    'FifteenKToTwentyK': '$15,000 - $20,000',
    'TwentyKToThirtyK': '$20,000 - $30,000',
    'ThirtyKToFortyK': '$30,000 - $40,000',
    'FortyKToFiftyK': '$40,000 - $50,000',
    'FiftyKToSeventyFiveK': '$50,000 - $75,000',
    'SeventyFiveKToOneHundredK': '$75,000 - $100,000',
    'OneHundredKAndUp': '$100,000+',
  };
  
  return budgetMap[budget] || budget;
};

export const formatSquareFootage = (footage: string | null | undefined): string => {
  if (!footage) return '';
  
  const footageMap: Record<string, string> = {
    'UnderTwelveHundred': 'Under 1,200 sq ft',
    'TwelveHundredToTwoThousand': '1,200 - 2,000 sq ft',
    'TwoThousandToThreeThousand': '2,000 - 3,000 sq ft',
    'OverThreeThousand': 'Over 3,000 sq ft',
  };
  
  return footageMap[footage] || footage;
};

export const formatProjectDuration = (duration: string | null | undefined): string => {
  if (!duration) return '';
  
  const durationMap: Record<string, string> = {
    'OneMonth': '1 month',
    'TwoMonths': '2 months',
    'ThreeMonths': '3 months',
    'FourToSixMonths': '4-6 months',
    'SeventToTwelveMonths': '7-12 months',
    'MoreThanAYear': 'More than 1 year',
  };
  
  return durationMap[duration] || duration;
};

export const formatProjectStyle = (style: string | null | undefined): string => {
  if (!style) return '';
  
  const styleMap: Record<string, string> = {
    'Traditional': 'Traditional',
    'Modern': 'Modern',
    'Contemporary': 'Contemporary',
    'Minimalist': 'Minimalist',
    'Industrial': 'Industrial',
    'Scandinavian': 'Scandinavian',
    'Bohemian': 'Bohemian',
    'Farmhouse': 'Farmhouse',
    'MidCentury': 'Mid-Century',
    'Rustic': 'Rustic',
    'Transitional': 'Transitional',
    'Mediterranean': 'Mediterranean',
    'ArtDeco': 'Art Deco',
    'Victorian': 'Victorian',
    'Colonial': 'Colonial',
  };
  
  return styleMap[style] || style;
};

export const formatSpecialRequirements = (requirements: string[] | null | undefined): string[] => {
  if (!requirements || !Array.isArray(requirements)) return [];
  
  const requirementsMap: Record<string, string> = {
    'AccessibilityFeatures': 'Accessibility Features',
    'EcoFriendlyMaterials': 'Eco-Friendly Materials',
    'SmartHomeIntegration': 'Smart Home Integration',
    'EnergyEfficientDesign': 'Energy Efficient Design',
    'PetFriendlyDesign': 'Pet-Friendly Design',
    'ChildSafeDesign': 'Child-Safe Design',
    'AgingInPlace': 'Aging in Place',
    'MultiGenerationalLiving': 'Multi-Generational Living',
    'HomeOfficeSpace': 'Home Office Space',
    'EntertainmentArea': 'Entertainment Area',
    'StorageSolutions': 'Storage Solutions',
    'NaturalLighting': 'Natural Lighting',
    'Soundproofing': 'Soundproofing',
    'SecurityFeatures': 'Security Features',
    'OutdoorLiving': 'Outdoor Living',
  };
  
  return requirements.map(req => requirementsMap[req] || req);
};






